import { gql } from "apollo-boost";
import { fragments } from "../queries/Service";

export default gql`
  mutation UpdateServiceMutation($id: ID!, $input: ServiceInput!) {
    updateService(id: $id, input: $input) {
      ...ServiceService
    }
  }
  ${fragments.service}
`;



// WEBPACK FOOTER //
// ./src/mutations/ChangeStatus.js